export const HERO_SECTION_YOUTUBE_PROPS = {
    autoplay: 1,
    controls: 0,
    mute: 1,
    keyboard: 1,
    autohide: 1,
    iv_load_policy: 3,
    modestbranding: 1,
    disablekb: 1,
    rel: 0,
    host: 'https://www.youtube.com',
    origin: window.location.origin,
    enablejsapi: 1,
    loop: 1,
};
export const YOUTUBE_VIDEO_STATUS = {
    readyToPlay: 1,
    buffering: 3,
};
export const YOUTUBE_ON = {
    STAGE: 'onStateChange',
    READY: 'onReady',
    ERROR: 'onError',
    END: 'onEnd',
};
